import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowtimeStreamingComponent } from './showtime-streaming/showtime-streaming.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { MovieDetailFeatureShowtimesModule } from '@usheru-hff/movie-detail/feature-showtimes';
import { FormsModule } from '@angular/forms';
import { ShowtimeStreamingSubscribeComponent, FormSubscriptionComponent } from '@usheru-hff/movie-detail/feature-subscribe';
import { MovieDetailFeatureEnquiriesModule } from '@usheru-hff/movie-detail/feature-enquiries';
import { MovieDetailFeatureStreamingModule } from '@usheru-hff/movie-detail/feature-streaming';
import { MovieDetailFeatureAtFestivalsModule } from '@usheru-hff/movie-detail/feature-at-festivals';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
@NgModule({
  imports: [
    CommonModule,
    SelectButtonModule,
    SharedUtilsTranslationModule,
    SharedUtilsModule,
    FormsModule,
    LoadingIndicatorComponent,
    MovieDetailFeatureShowtimesModule,
    ShowtimeStreamingSubscribeComponent, 
    FormSubscriptionComponent,
    MovieDetailFeatureEnquiriesModule,
    MovieDetailFeatureStreamingModule,
    MovieDetailFeatureAtFestivalsModule
  ],
  declarations: [ShowtimeStreamingComponent],
  exports: [ShowtimeStreamingComponent]
})
export class MovieDetailFeatureShowtimesStreamingModule {}
